import React from "react";
import ActivityLogs from "./activityLogs";

export default function ActivityLogsPage() {
  return <ActivityLogs />;
}